import React, {Component} from 'react';
import LoadingElement from '../LoadingElement';
import MessageListVideo from './MessageListVideo';
import MessageListPicture from './MessageListPicture';
import MessageListSuggestions from './MessageListSuggestions';
import MessageListLink from './MessageListLink';
import MessageListText from './MessageListText';
import Radium from 'radium';
import color from 'color';

class MessageList extends Component {

	constructor(props) {
		super(props);

		this.state = {
			lastElement: null,
			lightboxMessage: null,
			hasScrolled: false
		}

		this.handleScroll = event => {
			this.setScrolled(event);
		};
	}

	componentDidMount() {
		this.scrollToBottom();
		this.messagesList.addEventListener('mousewheel', this.handleScroll, true);
		this.messagesList.addEventListener('DOMMouseScroll', this.handleScroll, true);
	}

	setScrolled(event) {
	    if (event.wheelDelta > 0 || event.detail < 0) {
	        this.setState({
        		hasScrolled: true
	        });
	    }
	}

	shouldComponentUpdate(nextProps, nextState) {
	    return (
	    	this.props.messages !== nextProps.messages ||
	    	this.props.pageState.get("loading") !== nextProps.pageState.get("loading") ||
	    	this.props.inputHeight !== nextProps.inputHeight ||
	    	this.props.suggestedResponses !== nextProps.suggestedResponses ||
    		this.state.lastElement !== nextState.lastElement ||
    		this.state.lightboxMessage !== nextState.lightboxMessage ||
    		this.state.hasScrolled !== nextState.hasScrolled ||
    		this.props.messageLoader.get("loading") !== nextProps.messageLoader.get("loading") || 
    		this.props.pageState.get("lastMessageHasError") !== nextProps.pageState.get("lastMessageHasError")
    	);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.messages !== this.props.messages || prevProps.suggestedResponses !== this.props.suggestedResponses) {

			this.setState({
				lastElement: this.props.messages.last(),
				hasScrolled: false
			});
			this.scrollToBottom();
		}

		if (prevState.hasScrolled !== this.state.hasScrolled) {
			this.messagesList.removeEventListener('mousewheel', this.handleScroll, true);
			this.messagesList.removeEventListener('DOMMouseScroll', this.handleScroll, true);
		}
	}

	handlePostBack(response) {
		this.props.onHandlePostBack(response);

		if (!this.props.client.get("isMobile")) {
			this.props.focusInputElement();
		}
	}

	scrollToBottom() {
		if (!this.messagesList) {
			return;
		}
		
		this.messagesList.scrollTop = this.messagesList.scrollHeight;
	}

	handleMessageClick(message) {
		this.props.retryMessage(message);
	}

	renderMessage(message, i) {
		if (message.get("type") === "text" || message.get("type") === "trigger") {
			return (
				<MessageListText 
					message={message}
					client={this.props.client}
					lastElement={this.state.lastElement}
					parentStyles={styles}
					pageState={this.props.pageState}
					isLastMessage={message === this.props.messages.last()}
					handleMessageClick={(message) => this.handleMessageClick(message)}
				/>
			)	
		} else if (message.get("type") === "link") {
			return (
				<MessageListLink 
					message={message}
					client={this.props.client}
					lastElement={this.state.lastElement}
					parentStyles={styles}
				/>
			)
		} else if (message.get("type") === "picture") {
			return (
				<MessageListPicture 
					message={message}
					lastElement={this.state.lastElement}
					styles={styles}
					setLightbox={this.props.setLightbox}
					scrollToBottom={() => !this.state.hasScrolled && this.scrollToBottom()}
				/>
			)
		} else if (message.get("type") === "video") {
			return (
				<MessageListVideo 
					message={message}
					lastElement={this.state.lastElement}
					styles={styles}
					setLightbox={this.props.setLightbox}
					scrollToBottom={() => !this.state.hasScrolled && this.scrollToBottom()}
				/>
			)
		}
	}

	renderAvatar(message) {
		if (message.source !== 'agent') {
			return
		}

		return (
			<div 
				className="message__avatar"
				style={[
					styles.message.avatar
				]}
			>
			</div>
		)
	}

	render() {
		const messagesList = this.props.messages.map((message, i) => {
			return (
				<div className="message-container" key={i} style={[styles.messageContainer]}>
					{this.renderMessage(message)}
					{this.renderAvatar(message)}
				</div>
			)
		});

		return (
			<div 
				id="messages-list" 
				style={[
					styles.messageList,
					{
						bottom: `${this.props.inputHeight}px`,
						maxHeight: `calc(100% - ${this.props.inputHeight}px)`
					},
					!this.props.pageState.get("loading") && styles.messageList.visible
				]} 
				ref={messagesList => this.messagesList = messagesList}
			>
				{messagesList}
				{(this.props.suggestedResponses.size > 0) && 
					<MessageListSuggestions 
						suggestedResponses={this.props.suggestedResponses}
						client={this.props.client}
						handlePostBack={this.handlePostBack.bind(this)}
						showElement={this.props.suggestedResponses.size > 0}
					/>
				}
				<LoadingElement showElement={this.props.messageLoader.get("loading")} />

				{/*  Need this becase padding bottom does not work on overflow elements in Firefox / IE */}
				<div className="padding-spacer" style={[styles.messageList.paddingSpacer]}></div>
			</div>
		)
	}
}	


// STYLES
const transformMessage = Radium.keyframes({
	'0%': { 
		transform: 'translateY(20px)',
		opacity: 0
	},
	'100%': { 
		transform: 'translateY(0px)' ,
		opacity: 1
	}
});

const progress = Radium.keyframes({
	'0%': { backgroundPosition: '-500px 0' },
	'100%': { backgroundPosition: '500px 0' }
});

const styles = {
	messageList: {
		padding: '14px 14px 0 14px',
	    position: 'absolute',
	    left: '0',
	    right: '0',
	    boxSizing: 'border-box',
	    overflowY: 'scroll',
	    WebkitOverflowScrolling: 'touch',
	    opacity: 0,
	    transitionDelay: '0.3s',
	    transitionDuration: '0.6s',
	    transitionProperty: 'opacity',
	    overflowStyle: '-ms-autohiding-scrollbar',
	    zIndex: 0,

	    visible: {
			opacity: '1'
	    },

	    paddingSpacer: {
	    	height: '20px'
	    }
	},

	messageContainer: {
		position: 'relative'
	},

	message: {
		body: {
			backgroundColor: '#e4e5ea',
			minHeight: '35px',
			margin: '6px 0',
			padding: '7px 12px',
			borderRadius: '12px',
			display: 'inline-block',
			maxWidth: '256px',
			boxSizing: 'border-box',
			wordBreak: 'break-word',
			textAlign: 'left',
			whiteSpace: 'pre-wrap',

			loading: {
				display: 'block',
				width: '256px',
				height: '35px',
				backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0.0) 0%, rgba(0,0,0,0.08) 15%, rgba(0,0,0,0) 30%)',
				backgroundSize: '500px',
				animationName: progress,
				animationDuration: '2s',
				animationIterationCount: 'infinite',
				animationTimingFunction: 'linear',
				animationFillMode: 'forwards'
			},

			hasError: {
				cursor: 'pointer',
				opacity: '0.75'
			},

			appear: {
				animationName: transformMessage,
				animationDuration: '0.2s',
			},

			emojis: {
				backgroundColor: 'transparent !important',
				padding: '0 !important',
				fontSize: '64px'
			},

			picture: {
				padding: '0',
				cursor: 'pointer',
				display: 'none',
				backgroundColor: 'transparent',

				loaded: {
					display: 'block'
				}
			}
		},

		avatar: {
			backgroundColor: '#86ce79',
			height: '16px',
			width: '16px',
			borderRadius: '50%',
			border: '2px solid white',
			position: 'absolute',
			bottom: '-2px',
			left: '-8px'
		},

		error: {
			fontSize: '12px',
			color: '#757575',
			marginTop: '-4px',
			cursor: 'pointer'
		},

		isOwnedByUser: {
			textAlign: 'right'
		}
	}
}

export default Radium(MessageList);


// WEBPACK FOOTER //
// ./src/components/MessageList/index.js